import { render, staticRenderFns } from "./CustomerHistoryModal.vue?vue&type=template&id=16350ad8&scoped=true&"
import script from "./CustomerHistoryModal.vue?vue&type=script&lang=js&"
export * from "./CustomerHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHistoryModal.vue?vue&type=style&index=0&id=16350ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16350ad8",
  null
  
)

export default component.exports